import React, { useState } from 'react';
import AdminLayout from '../../components/layout/AdminLayout';
import toast from 'react-hot-toast';

const MODULES = [
  { id:"agri",      name:"Agri (Current)", icon:"", color:"#1A6B3C", desc:"Crop farming, farmers, buyers, agents", status:"active",   features:["Crops","Requests","Feed","Marketplace"] },
  { id:"nursery",   name:"Nursery",        icon:"", color:"#4D7C0F", desc:"Plants, seeds, pots, garden supplies",  status:"planned",  features:["Products","Stock","Orders","Catalog"] },
  { id:"ecommerce", name:"eCommerce",      icon:"🛒", color:"#4338CA", desc:"General products, cart, payments",       status:"planned",  features:["Products","Cart","Orders","Payments"] },
  { id:"organic",   name:"Organic",        icon:"", color:"#065F46", desc:"Certified organic, traceability",        status:"planned",  features:["Certifications","Products","Traceability"] },
  { id:"land",      name:"Land",           icon:"🏡", color:"#92400E", desc:"Land listings, lease, buy/sell",         status:"planned",  features:["Listings","Maps","Documents"] },
  { id:"equipment", name:"Equipment",      icon:"🚜", color:"#1E40AF", desc:"Tractor, tools rental marketplace",      status:"planned",  features:["Listings","Rental","Calendar"] },
];

export default function ModulesPage() {
  const [modules, setModules] = useState(MODULES);

  const toggle = (id) => {
    setModules(p => p.map(m => {
      if (m.id !== id) return m;
      if (m.id === "agri") { toast.error("Cannot disable active module"); return m; }
      const next = m.status === "active" ? "disabled" : "active";
      toast.success(m.name + " " + (next==="active"?"enabled":"disabled"));
      return { ...m, status:next };
    }));
  };

  return (
    <AdminLayout title="Module Management">
      <div className="alert alert--info" style={{ marginBottom:20 }}>
        🏗️ Each module has its own theme, features, and admin panel. Enable modules to activate them for users.
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))", gap:16 }}>
        {modules.map(m => (
          <div key={m.id} className="card" style={{ borderTop:"3px solid "+m.color }}>
            <div className="card__body">
              <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:12 }}>
                <div style={{ width:44,height:44,borderRadius:10,background:m.color+"22",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22 }}>{m.icon}</div>
                <div style={{ flex:1 }}>
                  <div style={{ fontWeight:700, fontSize:15 }}>{m.name}</div>
                  <span className={"badge "+(m.status==="active"?"badge--success":m.status==="disabled"?"badge--danger":"badge--gray")}>
                    {m.status}
                  </span>
                </div>
              </div>
              <div style={{ fontSize:13, color:"#6C757D", marginBottom:12 }}>{m.desc}</div>
              <div style={{ display:"flex", flexWrap:"wrap", gap:6, marginBottom:14 }}>
                {m.features.map(f => <span key={f} className="badge badge--gray">{f}</span>)}
              </div>
              <button className={"btn btn--sm "+(m.status==="active"?"btn--danger":"btn--success")+" btn--full"}
                onClick={() => toggle(m.id)} disabled={m.id==="agri"}>
                {m.id==="agri" ? "✅ Active (Current)" : m.status==="active" ? "Disable Module" : "Enable Module"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}
